module.exports = {
  apiServerUrl: '/'
};
